import React from 'react';
import { PropTypes } from 'prop-types';
import { FaClock } from 'react-icons/fa';

import { Spinner } from '~/components/Spinner';
import ClearBackground from '~/components/ClearBackground';

import { Container, Content, Icon, MessageContent, Header } from './styles';

const CreatingChecklistMessage = ({ period }) => {
  return (
    <>
      <Container>
        <Content>
          <Icon>
            <FaClock size={38} color="#01579b" />
          </Icon>
          <MessageContent>
            <Header>
              <strong>Aguarde</strong>
            </Header>
            <span>
              Criando checklist <strong>{period}</strong>. Isto pode demorar um
              pouco.
            </span>
            <div>
              <Spinner />
            </div>
          </MessageContent>
        </Content>
      </Container>
      <ClearBackground />
    </>
  );
};

export default CreatingChecklistMessage;

CreatingChecklistMessage.propTypes = {
  period: PropTypes.string.isRequired,
};
